import React, { Fragment } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import axios from "axios";

import CustomDialog from "nekrasovka-ui/CustomDialog";
import Input from "nekrasovka-ui/Input";
import Button from "nekrasovka-ui/Button";

import editing from "modules/editing";
import Icon from "nekrasovka-ui/Icons";

const { editingToggle, fetchEdits } = editing.actions;

const RaisedButton = styled(Button)`
  background: #40677e;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.03);
  border-radius: 5px;

  font-family: Rubik, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  padding: 5px 10px;
  color: #ffffff;

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 3px 10px;
  }
`;

const Text = styled(Input)`
  padding: 10px;

  & input,
  & input::placeholder {
    font-family: Rubik, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;

    color: #999999;
  }

  @media (max-width: 568px) {
    & input::placeholder {
      color: #999 !important;
    }
  }

  @media (max-width: 1024px) {
    & input {
      font-size: 14px;
    }
  }
`;

const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  & input {
    border: none;
  }

  > div {
    flex-grow: 1;
    border: none;

    &:first-child {
      margin-right: 20px;
    }
  }

  @media (max-width: 768px) {
    flex-flow: column nowrap;

    > div:first-child {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
`;

const FileInputContainer = styled.div`
  position: relative;
  overflow: hidden;
  cursor: pointer;

  font-family: Rubik, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 100%;

  color: #999999;

  margin-left: 20px;

  &:hover {
    cursor: pointer;
  }

  svg {
    margin-right: 5px;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    margin-left: 0;
  }
`;

const StyledInput = styled.input`
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  font-size: 999px;
  cursor: pointer;
  opacity: 0;
`;

const EditButtonsContainer = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    justify-content: space-between;
  }
`;

const Textarea = styled.textarea`
  & {
    width: 100%;
    border: none;
    height: 100px;
    padding: 15px;
    display: block;
    box-sizing: border-box;
    margin-bottom: 15px;
    font-size: 15px;
    line-height: 26px;
    font-family: Rubik, sans-serif;

    color: #999999;

    @media (max-width: 568px) {
      font-size: 12px;
      margin-bottom: 10px;
    }
  }
`;

const Mention = styled.div`
  & {
    margin-bottom: 15px;
    background: #fff;
    padding: 15px;

    span {
      font-family: Merriweather, sans-serif;
      font-style: normal;

      font-size: 15px;
      line-height: 25px;

      @media (max-width: 568px) {
        font-size: 14px;
        margin-bottom: 10px;
      }
    }
  }
`;

class Editing extends React.Component {
  constructor() {
    super();

    this.state = {
      editor_name: "",
      editor_email: "",
      magazine_id: 1,
      file: "Прикрепить файл",
      comment: "",
    };

    this.editingRef = React.createRef();
  }

  componentDidMount() {
    if (localStorage.editor_name) {
      this.setState({
        editor_name: localStorage.editor_name,
        editor_email: localStorage.editor_email,
      });
    }

    this.editingRef.current &&
      this.editingRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
  }

  handleFileInput = (e) => {
    if (this.state.editor_email === "" || this.state.editor_name === "")
      return alert("Введите, пожалуйста, ваше имя и адрес электронной почты");
    const data = new FormData();

    const fileName = e.target.files[0].name;
    data.append("attachment", e.target.files[0]);
    data.append("editor_name", this.state.editor_name);
    data.append("editor_email", this.state.editor_email);

    axios
      .post(`${process.env.REACT_APP_API_SERVER}/attachment/store`, data, {
        onUploadProgress: (progressEvent) =>
          console.log(
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
          ),
      })
      .then((res) => {
        if (res.data.hasOwnProperty("attach_id")) {
          this.setState({
            attach_id: res.data.attach_id,
            file: fileName,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  handleClick = () => {
    const data = {};

    if (this.mention) {
      const items = this.mention.children;
      Object.keys(items).map(
        (item) =>
          (data[items[item].getAttribute("type")] = items[item].innerText)
      );
    } else {
      const items = this.person.children;
      Object.keys(items).map(
        (item) =>
          (data[items[item].getAttribute("type")] = items[item].innerText)
      );
    }
    if (this.state.editor_email === "") {
      return alert("Поле email не может быть пустым");
    }

    if (this.state.editor_name === "") {
      return alert("Введите пожалуйста ваше имя");
    }

    localStorage.editor_name = this.state.editor_name;
    localStorage.editor_email = this.state.editor_email;

    this.setState({ ...data }, () => {
      this.props.fetchEdits(this.state, this.props.field.id, this.props.entity);
      document.body.style.overflow = "auto";
      this.setState({
        file: "Прикрепить файл",
      });
    });
  };

  render() {
    const { field, entity, editing } = this.props;

    return (
      <div ref={this.editingRef}>
        <CustomDialog
          {...this.props}
          colorTitle="#999999"
          title="Режим редактирования"
          open={editing}
          onRequestClose={() => this.props.editingToggle(field)}
        >
          {entity === "mention" && (
            <Mention ref={(target) => (this.mention = target)}>
              <span contentEditable="true" type="magazine">
                {field.magazine}
              </span>
              .
              <span contentEditable="true" type="year">
                {field.year}
              </span>
              .
              {field.edition_id && (
                <Fragment>
                  <span contentEditable="true" type="edition_id">
                    {field.edition_id}
                  </span>
                  -е изд.
                </Fragment>
              )}
              {field.magazine_id === 2 ? "книга" : "Т."}{" "}
              <span contentEditable="true" type="volume">
                {field.volume}
              </span>
              ,
              <span contentEditable="true" type="numbers">
                {field.numbers}
              </span>
              .
              <MentionPages page={field.page} pages={field.pages} />
            </Mention>
          )}
          {entity === "person" && (
            <div
              ref={(target) => (this.person = target)}
              contentEditable="true"
            >
              <div
                type="name"
                style={{
                  background: "#fff",
                  marginBottom: "20px",
                  padding: "20px",
                  fontSize: "15px",
                  lineHeight: "26px",
                }}
              >
                {field.name.replace(/<[^>]*>/g, "")}
              </div>
              <div
                type="description"
                style={{
                  background: "#fff",
                  marginBottom: "20px",
                  padding: "20px",
                  fontSize: "14px",
                  lineHeight: "26px",
                }}
              >
                {field.description.replace(/<[^>]*>/g, "")}
              </div>
            </div>
          )}
          <Textarea
            onChange={() => this.setState({ comment: this.textarea.value })}
            ref={(target) => (this.textarea = target)}
            name="comment"
            cols="30"
            rows="10"
            placeholder="Ваш комментарий"
          />
          <InputContainer>
            <Text
              font={14}
              placeholder="Ф.И.О"
              value={this.state.editor_name}
              onChange={(e) => this.setState({ editor_name: e.target.value })}
            />
            <Text
              font={14}
              placeholder="e-mail для связи"
              value={this.state.editor_email}
              onChange={(e) => this.setState({ editor_email: e.target.value })}
            />
          </InputContainer>
          <EditButtonsContainer>
            <RaisedButton onClick={() => this.handleClick()}>
              Предложить правки
            </RaisedButton>
            <FileInputContainer>
              <span style={{ display: "flex" }}>
                <Icon width={12} fill="#444444" icon="attach" />
                {this.state.file}
              </span>
              <StyledInput
                type="file"
                id="file"
                onChange={this.handleFileInput}
              />
            </FileInputContainer>
          </EditButtonsContainer>
        </CustomDialog>
      </div>
    );
  }
}

const MentionPages = ({ page, pages }) => {
  const isPagesLength = !!pages.length;

  const addComment = (comment) => (!!comment ? ` (${comment})` : "");

  const constructPagesString = () =>
    pages.map((page) => `${page.title}${addComment(page.comment)}`).join(", ");

  return (
    <span contentEditable="true" type="page">
      {isPagesLength ? `С. ${constructPagesString()}` : page}
    </span>
  );
};

const mapStateToProps = (state) => ({
  editing: state.editing.editing,
  field: state.editing.field,
  entity: state.editing.entity,
});

export default connect(mapStateToProps, { editingToggle, fetchEdits })(Editing);



// WEBPACK FOOTER //
// ./src/containers/Editing/index.js